import Vue from 'vue'
import { GET_ISSUES } from '../mutation-types.js'

export const getIssues = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('issue')
        .then(
            (response) => {
              dispatch(GET_ISSUES, response.json())
              resolve()
            },
            (response) => {
              reject()
            })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/issuesActions.js